/**
 * Manifest dei blocchi della pagina di dettaglio.
 *
 * I due flussi (only-stay / flight-and-stay) condividono la stessa spina
 * dorsale e differiscono solo per quali blocchi compaiono e con quali props.
 * Ogni blocco continua a decidere da se` se ha dati da mostrare: qui si decide
 * soltanto se montarlo.
 */

import {
  hotel_gallery_images,
  product_gallery_images,
} from '@alpitour/utilities/images';

// categoriaUff non e` sempre numerica: "4X" -> 4, "BB" e "NC" -> nessuna stella.
const parse_stars = (value) => {
  const raw = value === null || value === undefined ? '' : String(value);
  // rating.stars e` gia` numerico e ammette le mezze stelle: va letto intero
  const stars = Number(raw) || Number(raw.slice(0, 1));

  return stars > 0 ? stars : null;
};

export const only_stay_header = (hotel = {}) => {
  const { location = {}, rating = {} } = hotel;
  const { city = '', country = '' } = location;

  return {
    name: hotel.name,
    stars: parse_stars(rating.stars),
    location_label: [city, country].filter(Boolean).join(', ').toLowerCase(),
    location: hotel.location || null,
    brand: hotel.brand,
    alpitour_rating: null,
  };
};

export const flight_and_stay_header = (product = {}, product_brand = '') => {
  const { baseProdotto = {}, editoriale = {} } = product;
  const { localita = '', nomeHotel = '' } = baseProdotto;
  const { categoriaUff, valutazioneAlpitour } = editoriale;

  let alpitour_rating = null;
  if (valutazioneAlpitour && valutazioneAlpitour !== 'NC') {
    alpitour_rating = valutazioneAlpitour.replace('/', '.5');
  }

  return {
    name: nomeHotel,
    stars: parse_stars(categoriaUff),
    location_label: localita.toLowerCase().replace('/', '-'),
    location: null,
    brand: product_brand,
    alpitour_rating,
  };
};

export const only_stay_blocks = (hotel_data = {}) => {
  const { data: hotel = {} } = hotel_data;
  const { descriptions = [] } = hotel;
  const props = { hotel_data };

  return [
    {
      component: 'gallery',
      props: { name: hotel.name, images: hotel_gallery_images(hotel) },
    },
    { component: 'description', props },
    {
      component: 'tabbed-info',
      props: { items: descriptions },
      when: descriptions.length > 0,
    },
    { component: 'rooms', props },
    { component: 'services-insurance', props, divided: true },
    { component: 'services-all', props, divided: true },
  ].filter((block) => block.when !== false);
};

export const flight_and_stay_blocks = ({
  product_detail = [],
  statics_detail = {},
  supplement = [],
} = {}) => {
  const props = { product_detail, statics_detail, supplement };
  const [product = {}] = product_detail;
  const { baseProdotto = {} } = product;
  const { keyd, nomeHotel, pid } = baseProdotto;
  const images = product_gallery_images(product_detail, statics_detail);

  return [
    { component: 'transfer', props: { keyd } },
    {
      component: 'gallery',
      props: { name: nomeHotel, images: images[pid] },
    },
    { component: 'panoramic-hotel', props },
    { component: 'panoramic-tour', props },
    { component: 'description', props },
    { component: 'accommodations', props },
    { component: 'solutions', props },
    { component: 'rating-tour', props },
    { component: 'program', props },
    { component: 'services-insurance', props },
    { component: 'services-popular', props },
    { component: 'services-all', props },
    { component: 'faq', props },
    { component: 'promo', props },
  ];
};
